import React from "react";
import "./Categories.css";
import { useStateValue } from "../StateProvider";

const categories = [
  "Silicones",
  "Sealants",
  "Adhesives",
  "Aerosols",
  "Guns",
  "PU Foam & Cleaner"
 ];

function Categories() {
  const [{}, dispatch] = useStateValue();

  const setActive = (e, category) => {
    let prevActive = document.querySelector(".categories__category.active");
    if (prevActive) prevActive.classList.remove("active");
    e.preventDefault();
    e.target.classList.add("active");
    dispatch({
      type: "SET_CATEGORY",
      category: category,
    });
  };

  return (
    <div className="categories">
      <span
        className="categories__category active"
        onClick={(e) => setActive(e, "all")}
      >
        All Products
      </span>
      {categories.map((category) => (
        <span
          className="categories__category"
          onClick={(e) => setActive(e, category)}
          key={category}
        >
          {category}
        </span>
      ))}
    </div>
  );
}
export default Categories;
